import React, {useState, useEffect, useContext} from 'react'
import axios from "axios";
import {UserContext} from "../UserContext";
import TripModal from "../TripModal";
import {getBearerToken, getServerUrl, countries} from "../utils/utils";
import {useParams} from "react-router-dom";
import WorldMap from "./WorldMap";
import globe from "../images/globe.png"


function WorldMapContainer() {
    const {id} = useParams()
    const {user} = useContext(UserContext)
    const [trips, setTrips] = useState([])
    const [location, setLocation] = useState(null)
    const [endpoint, setEndpoint] = useState(null)

    const fetchTrips = async () => {
        axios.get(`${getServerUrl()}/user/${id || user?.id}/trip`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setTrips(response.data)
            })
    }

    useEffect(() => {
        if (user?.id) {
            fetchTrips()
        }
    }, [user])

    const getNumCountriesVisited = () => {
        let numStates = 0;
        for (let i = 0; i < countries.length; i++) {
            const countryName = countries[i].name
            for (let j = 0; j < trips.length; j++) {
                const trip = trips[j]
                if (trip.country === countryName) {
                    numStates++;
                    j = trips.length;
                }
            }
        }
        return numStates
    }


    return (
        <div style={{width: "100%", height: "calc(100vh - 66px)", position: "relative"}} id="europe-map-container">
            <div className="world-progress-container">
                <img src={globe}/>
                <div className="teams-visited-summary">
                    <div style={{color: "#001489"}}>{`${getNumCountriesVisited()} countries visited`}</div>
                    <div style={{color: "#D50A0A"}}> {`${countries.length - getNumCountriesVisited()} countries remaining`}</div>
                </div>
            </div>
            {/*{window.innerWidth > 800 && (*/}
            {/*    <>*/}
            {/*        <div className="states-list" style={{left: 0}}>*/}
            {/*            {displayCountryList(true)}*/}
            {/*        </div>*/}
            {/*        <div className="states-list" style={{right: 0}}>*/}
            {/*            {displayCountryList(false)}*/}
            {/*        </div>*/}
            {/*    </>*/}
            {/*)}*/}
            <WorldMap
                locations={trips}
                //     setOpenTripModal={selectedLocation => {
                //     setLocation(selectedLocation)
                // }}
                onMarkerEvent={selectedLocation => {
                    setLocation(selectedLocation)
                    setEndpoint(`/user/${id || user?.id}/trip/location/`)
                }}
                setLocation={selectedLocation => {
                    setLocation(selectedLocation)
                    setEndpoint("/country/")
                }}
            />

            <TripModal location={location} fullscreen={true} endpoint={endpoint}/>
        </div>
    )
}

export default WorldMapContainer;

